<template>
  <v-container fluid color="white--text">
    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-text>
            <h3>Business to Beneficiary</h3>
            <p>
              As a merchant, you can credit your beneficiaries accounts from your non-WAAS utility account. To credit your beneficiary account, follow the instructions below.
            </p>
          </v-card-text>
          <v-divider/>
          <v-card-text>
            EndPoints:<br/>
            <div class="secondary" style="color: #e7e3fc">
              <strong>Sandbox</strong>
              <p class="ma-2">{{"https://sandbox.sasapay.app/api/v1/payments/b2b/"}}</p>
              <v-divider/>
              <strong>Production</strong>
              <p class="ma-2">{{"https://sandbox.sasapay.app/api/v1/payments/b2b/"}}</p>
            </div>
          </v-card-text>
          <v-divider/>
          <v-card-text>
            Request Parameters <br/>
            <code>
              "MerchantCode": "9***0",<br/>
              "MerchantTransactionReference": "87065",<br/>
              "Currency":"KES",<br/>
              "Amount": 1,<br/>
              "ReceiverMerchantCode": "3209",<br/>
              "CallBackURL": "https://******.io/4bdd-47d5-a54d",<br/>
              "Reason": "Payment of transportation fee"
            </code>

          </v-card-text>
          <v-divider/>
          <v-card-text>
            Expected Results:<br/>

            Sasa<span class="red--text">Pay</span> returns the status code & a detailed message
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="">
        <h3>Sample Request</h3>
        <code-editor
            :read_only="true"
            theme="dark"
            v-model="code"
            @change="changeLanguage"
            :wrap_code="false"
            :language_selector="true"
            class="github_dark"
            :copy_code="true"
            font_size="16px"
            height="50%"
            width="100%"
            :languages="[['python', 'Python'],['php','Laravel'],['java','Java'],['go','Go'],['csharp','C#'],['javascript', 'Node Js']]"
        ></code-editor>
        <v-divider/>
        <h3>Sample Response</h3>
        <code-editor
            :read_only="true"
            theme="dark"
            v-model="response"
            :wrap_code="false"
            :language_selector="true"
            class="github_dark"
            :copy_code="true"
            font_size="16px"
            height="50%"
            width="100%"
            :languages="[['json','JSON']]"
        ></code-editor>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import {getB2BRequest, getB2BResponse} from "../../../../../shared/snippets/b2c/b2c";

export default {
  name: "C2B",
  // components: { VueStylelintEditor },
  data: () =>({
    selectedLanguage:"",
    code:"",
    response:"",
  }),
  mounted() {
    this.importSnippets()//
    this.importResponse()
  },
  methods:{
    importSnippets(){
      this.code=getB2BRequest()
    },
    importResponse(){
      this.response=getB2BResponse()
    },
    changeLanguage() {
      console.log(this.code)
    }
  }
}
</script>

<style scoped>

</style>